module.exports = __webpack_public_path__ + "img/darkBrown_attached.2256dca4.svg";